const oldPortalUrl = 'https://manage.fieldassist.in/';
const dashboardAPIUrl = 'https://fadashboardv2.azurewebsites.net/';
//const dashboardAPIUrl = 'https://localhost:5001/';


export {
    oldPortalUrl,
    dashboardAPIUrl,
}